<template>
  <div class="contain">
    <!-- <div class="title">科目余额表</div> -->
    <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
      <el-form-item>
        <strong slot="label">月份</strong>
        <el-date-picker
          v-model="formInline.date"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          format="yyyy-MM"
          value-format="yyyy-MM"
          @change="inquire">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <strong slot="label">账套</strong>
        <el-select v-model="formInline.accountType" placeholder="请选择账套" filterable @change="inquire">
          <el-option v-for="(item, index) in dropDown.subjectAccountType2" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <strong slot="label">科目类型</strong>
        <el-select v-model="formInline.subjectType" placeholder="请选择科目类型" filterable @change="inquire" clearable>
          <el-option v-for="(item, index) in dropDown.subjectType" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
      v-loading="loading"
      border
      :height="tableHeight"
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table
            :data="scope.row.children"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
            border
          >
            <el-table-column prop="resourceName" label="名称" header-align="center" min-width="100"></el-table-column>
              <el-table-column label="期初" header-align="center">
                <el-table-column prop="initialQuantity" label="数量" header-align="center" align="right" width="80">
                  <template slot-scope="scope">
                    {{scope.row.initialQuantity ? scope.row.initialQuantity : ''}}
                  </template>
                </el-table-column>
                <el-table-column prop="initialPrice" label="单价" header-align="center" align="right" width="150">
                  <template slot-scope="scope">
                    {{scope.row.initialPrice | comdify('no')}}
                  </template>
                </el-table-column>
                <el-table-column prop="initialLinetotal" label="金额" header-align="center" align="right" width="150">
                  <template slot-scope="scope">
                    {{scope.row.initialLinetotal | comdify('no')}}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="入库" header-align="center">
                <el-table-column prop="inQuantity" label="数量" header-align="center" align="right" width="80">
                  <template slot-scope="scope">
                    {{scope.row.inQuantity ? scope.row.inQuantity : ''}}
                  </template>
                </el-table-column>
                <el-table-column prop="inPrice" label="单价" header-align="center" align="right" width="150">
                  <template slot-scope="scope">
                    {{scope.row.inPrice | comdify('no')}}
                  </template>
                </el-table-column>
                <el-table-column prop="inLinetotal" label="金额" header-align="center" align="right" width="150">
                  <template slot-scope="scope">
                    {{scope.row.inLinetotal | comdify('no')}}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="出库" header-align="center">
                <el-table-column prop="outQuantity" label="数量" header-align="center" align="right" width="80">
                  <template slot-scope="scope">
                    {{scope.row.outQuantity ? scope.row.outQuantity : ''}}
                  </template>
                </el-table-column>
                <el-table-column prop="outPrice" label="单价" header-align="center" align="right" width="150">
                  <template slot-scope="scope">
                    {{scope.row.outPrice | comdify('no')}}
                  </template>
                </el-table-column>
                <el-table-column prop="outLinetotal" label="金额" header-align="center" align="right" width="150">
                  <template slot-scope="scope">
                    {{scope.row.outLinetotal | comdify('no')}}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="期末" header-align="center">
                <el-table-column prop="quantity" label="数量" header-align="center" align="right" width="80">
                  <template slot-scope="scope">
                    {{scope.row.quantity ? scope.row.quantity : ''}}
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="单价" header-align="center" align="right" width="150">
                  <template slot-scope="scope">
                    {{scope.row.price | comdify('no')}}
                  </template>
                </el-table-column>
                <el-table-column prop="linetotal" label="金额" header-align="center" align="right" width="150">
                  <template slot-scope="scope">
                    {{scope.row.linetotal | comdify('no')}}
                  </template>
                </el-table-column>
              </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="subjectName" label="存货科目" header-align="center"></el-table-column>
      <el-table-column prop="restypeNumber" label="存货编号" align="center" width="150"></el-table-column>
      <el-table-column prop="restypeName" label="名称" header-align="center" min-width="100"></el-table-column>
      <el-table-column label="期初" header-align="center">
        <el-table-column prop="initialQuantity" label="数量" header-align="center" align="right" width="80">
          <template slot-scope="scope">
            {{scope.row.initialQuantity ? scope.row.initialQuantity : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="initialPrice" label="单价" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            {{scope.row.initialPrice | comdify('no')}}
          </template>
        </el-table-column>
        <el-table-column prop="initialLinetotal" label="金额" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            {{scope.row.initialLinetotal | comdify('no')}}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="入库" header-align="center">
        <el-table-column prop="inQuantity" label="数量" header-align="center" align="right" width="80">
          <template slot-scope="scope">
            {{scope.row.inQuantity ? scope.row.inQuantity : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="inPrice" label="单价" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            {{scope.row.inPrice | comdify('no')}}
          </template>
        </el-table-column>
        <el-table-column prop="inLinetotal" label="金额" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            {{scope.row.inLinetotal | comdify('no')}}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="出库" header-align="center">
        <el-table-column prop="outQuantity" label="数量" header-align="center" align="right" width="80">
          <template slot-scope="scope">
            {{scope.row.outQuantity ? scope.row.outQuantity : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="outPrice" label="单价" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            {{scope.row.outPrice | comdify('no')}}
          </template>
        </el-table-column>
        <el-table-column prop="outLinetotal" label="金额" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            {{scope.row.outLinetotal | comdify('no')}}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="期末" header-align="center">
        <el-table-column prop="quantity" label="数量" header-align="center" align="right" width="80">
          <template slot-scope="scope">
            {{scope.row.quantity ? scope.row.quantity : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="price" label="单价" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            {{scope.row.price | comdify('no')}}
          </template>
        </el-table-column>
        <el-table-column prop="linetotal" label="金额" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            {{scope.row.linetotal | comdify('no')}}
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import url from '@/config/url'
import * as XLSX from 'xlsx'
import { mapState } from 'vuex'
import handleTree from '@/utils/handleTree'
  export default {
    computed: {
      ...mapState ({
        dropDown: state => state.dropDown.dropDown
      })
    },
    data() {
      return {
        tableData: [],
        loading: true,
        formInline: {
          date: [JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).name : (new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) > 9 ? (new Date().getMonth() + 1) : '0' + (new Date().getMonth() + 1))),
          JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).name : (new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) > 9 ? (new Date().getMonth() + 1) : '0' + (new Date().getMonth() + 1)))],
          // date: ['2013-01', '2023-08'],
          accountType: '',
          subjectType: '',
          nbzzId:JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).nbzzId : -1,
        },
        tableHeight: window.innerHeight - 193
      }
    },
    created () {
      // 获取账套类型下拉
      if(!this.dropDown.subjectAccountType2){
        this.$http.get(url.getDataList, {params: {type: 'buss_subject_account_type2'}}).then(res => {
          if(res.data.code == 200) {
            this.$store.commit('setSubjectAccountType2', res.data.data)
          }
        })
      }
      // 获取科目类型下拉
      if(!this.dropDown.subjectType){
        this.$http.get(url.getDataList, {params: {type: 'buss_subject_type'}}).then(res => {
          if(res.data.code == 200) {
            this.$store.commit('setSubjectType', res.data.data)
          }
        })
      }
      this.getList();
      // window.addEventListener('setItem', ()=> {
      //   // console.log(JSON.parse(sessionStorage.getItem('date')));
      //   this.formInline.date = [JSON.parse(sessionStorage.getItem('date')).name, JSON.parse(sessionStorage.getItem('date')).name]
      //   this.formInline.nbzzId = JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).nbzzId : -1
      //   this.getList()
      // })
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 193;
      })
      window.onresize = () => {   //屏幕尺寸变化就重新赋值
        return (() => {
          this.tableHeight = window.innerHeight - 193;
        })()
      }
    },
    methods: {
      getExportTextWidth(value) {
        if (value === undefined || value === null) {
          return 0
        }
        return String(value).split('').reduce((width, char) => {
          return width + (char.charCodeAt(0) > 255 ? 2 : 1)
        }, 0)
      },
      setWorksheetCols(workSheet, tableData) {
        if (!tableData || !tableData.length) {
          return
        }
        const colCount = tableData[0].length
        workSheet['!cols'] = Array.from({ length: colCount }).map((_, colIndex) => {
          const maxWidth = tableData.reduce((width, row) => {
            return Math.max(width, this.getExportTextWidth(row[colIndex]))
          }, 0)
          return {
            wch: Math.min(Math.max(maxWidth + 2, 12), 30)
          }
        })
      },
      buildInventoryExportTableData() {
        const columns = [
          '记录类型',
          '存货科目',
          '存货编号',
          '名称',
          '期初数量',
          '期初单价',
          '期初金额',
          '入库数量',
          '入库单价',
          '入库金额',
          '出库数量',
          '出库单价',
          '出库金额',
          '期末数量',
          '期末单价',
          '期末金额'
        ]
        const rows = [columns]
        this.tableData.forEach(row => {
          rows.push([
            '主表',
            row.subjectName === undefined || row.subjectName === null ? '' : row.subjectName,
            row.restypeNumber === undefined || row.restypeNumber === null ? '' : row.restypeNumber,
            row.restypeName === undefined || row.restypeName === null ? '' : row.restypeName,
            row.initialQuantity === undefined || row.initialQuantity === null ? '' : row.initialQuantity,
            row.initialPrice === undefined || row.initialPrice === null ? '' : row.initialPrice,
            row.initialLinetotal === undefined || row.initialLinetotal === null ? '' : row.initialLinetotal,
            row.inQuantity === undefined || row.inQuantity === null ? '' : row.inQuantity,
            row.inPrice === undefined || row.inPrice === null ? '' : row.inPrice,
            row.inLinetotal === undefined || row.inLinetotal === null ? '' : row.inLinetotal,
            row.outQuantity === undefined || row.outQuantity === null ? '' : row.outQuantity,
            row.outPrice === undefined || row.outPrice === null ? '' : row.outPrice,
            row.outLinetotal === undefined || row.outLinetotal === null ? '' : row.outLinetotal,
            row.quantity === undefined || row.quantity === null ? '' : row.quantity,
            row.price === undefined || row.price === null ? '' : row.price,
            row.linetotal === undefined || row.linetotal === null ? '' : row.linetotal
          ])
          ;(row.children || []).forEach(child => {
            rows.push([
              '明细',
              '',
              '',
              child.resourceName === undefined || child.resourceName === null ? '' : child.resourceName,
              child.initialQuantity === undefined || child.initialQuantity === null ? '' : child.initialQuantity,
              child.initialPrice === undefined || child.initialPrice === null ? '' : child.initialPrice,
              child.initialLinetotal === undefined || child.initialLinetotal === null ? '' : child.initialLinetotal,
              child.inQuantity === undefined || child.inQuantity === null ? '' : child.inQuantity,
              child.inPrice === undefined || child.inPrice === null ? '' : child.inPrice,
              child.inLinetotal === undefined || child.inLinetotal === null ? '' : child.inLinetotal,
              child.outQuantity === undefined || child.outQuantity === null ? '' : child.outQuantity,
              child.outPrice === undefined || child.outPrice === null ? '' : child.outPrice,
              child.outLinetotal === undefined || child.outLinetotal === null ? '' : child.outLinetotal,
              child.quantity === undefined || child.quantity === null ? '' : child.quantity,
              child.price === undefined || child.price === null ? '' : child.price,
              child.linetotal === undefined || child.linetotal === null ? '' : child.linetotal
            ])
          })
        })
        return rows
      },
      handleExport() {
        if (!this.tableData || !this.tableData.length) {
          this.$message.warning('暂无可导出数据')
          return
        }
        const tableData = this.buildInventoryExportTableData()
        const workSheet = XLSX.utils.aoa_to_sheet(tableData)
        this.setWorksheetCols(workSheet, tableData)
        const workBook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workBook, workSheet, '存货明细账')
        XLSX.writeFile(workBook, '存货明细账.xlsx')
      },
      getList() {
        this.tableData = []
        this.loading = true
        this.$http.get(url.inventoryAccount, {params: {
          accountType: this.formInline.accountType,
          startDate: this.formInline.date ? this.formInline.date[0] : '',
          endDate: this.formInline.date ? this.formInline.date[1] : '',
          subjectType: this.formInline.subjectType,
            nbzzId: this.formInline.nbzzId
        }}).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            this.tableData = res.data.data.list
          }
        })
      },
      inquire() {
        this.getList()
      }
    },
  }
</script>

<style lang="scss" scoped>
.contain {
  padding: 16px;
  background-color: #fff;
  border-radius: 11px;
  .title {
    text-align: center;
    font-size: 18px;
    font-weight: 900;
    margin-bottom: 16px;
  }
}
</style>
